import { render } from "./Payments.vue?vue&type=template&id=0de4e505"
import script from "./Payments.vue?vue&type=script&lang=js"
export * from "./Payments.vue?vue&type=script&lang=js"
script.render = render

export default script